import { Box, Text } from '@zillow/constellation';
import React from 'react';

import { mapPostsToGridFormat } from '../../util/postAdapters';
import PostGrid from '../PostGrid/PostGrid';

import type { AuthorMainContentProps } from './AuthorPage.types';

/**
 * Main content area for the author page, displaying the author's latest articles.
 */
const AuthorMainContent: React.FC<Omit<AuthorMainContentProps, 'total'>> = ({
    author,
    posts,
    pages,
    initialPage,
}) => {
    // Construct baseLink for author pagination
    // Prefer author.link or author.slug if available, fallback to /learn/author/[id]
    const baseLink = author.link || `/learn/author/${author.id}`;

    return (
        <Box
            sx={{
                flex: 1,
                backgroundColor: '$colors.white',
                borderRadius: '$radii.xl',
                paddingTop: '$spacing.md',
                paddingBottom: '$spacing.md',
                boxShadow: '$shadows.lg',
                maxWidth: '$breakpoints.lg',
                minHeight: '400px',
                '@media $lg': {
                    marginTop: 0, // Sits below header, not overlapping
                },
            }}
        >
            <Text
                as="h2"
                fontType={{ default: 'h4', lg: 'h3' }}
                marginBottom="md"
            >
                {author.name}&apos;s Latest Articles
            </Text>
            {/*
              The posts prop comes from shared Post type, but PostGrid expects posts from types/posts.
              The structures are compatible for display, so we cast here for type compatibility.
            */}
            <PostGrid
                posts={mapPostsToGridFormat(posts)}
                pages={pages}
                page={initialPage}
                baseLink={baseLink}
            />
        </Box>
    );
};

export default AuthorMainContent;
